import { useEffect } from 'react';

export default function useStickyHeader({ stickyHeader, tableRef, rows }) {
  useEffect(() => {
    if (!tableRef.current || !stickyHeader || !rows.length) {
      return;
    }
    
    const container = document.querySelector(stickyHeader.scrollContainer);
    const observerAnchor = tableRef.current.querySelector('.sticky-header-observer-anchor');
    
    if (!container || !observerAnchor) {
      return;
    }
    
    const headerCells = tableRef.current.querySelectorAll(':scope > thead th');
    const headerHeight = tableRef.current.querySelector(':scope > thead')?.offsetHeight || 0;
    
    const observer = new IntersectionObserver(
      ([entry]) => {
        const observerAnchorTop = entry.boundingClientRect.top;
        const containerTop = entry.rootBounds.top;
        const isHeaderOutOfSpace = observerAnchorTop <= containerTop + headerHeight;
        const shouldStop = isHeaderOutOfSpace && !entry.isIntersecting;
        
        headerCells.forEach(th => {
          th.classList.toggle('th-hidden', shouldStop);
        });
      },
      {
        root: container,
        threshold: 0,
        rootMargin: `-39px 0px 0px 0px`,
      }
    );
    
    observer.observe(observerAnchor);
    
    return () => observer.disconnect();
  }, [rows, stickyHeader]);
}
